<template>
    <div class="page-home">
        <vue-headful 
            :title="$PPlusEngine.getDictionary($route.params.lang, 
                'Get Your AML Skills Certified - ProbPlus', 
                'Get Your AML Skills Certified - ProbPlus')" 
            :description="$PPlusEngine.getDictionary($route.params.lang, 
                'เปิดโลกรู้เท่าทันการฟอกเงินด้วยหลักสูตรที่ได้รับการรับรองโดยสำนักงานปปง.กับ ProbPlus ได้แล้ววันนี้ หลักสูตรภาษาไทยราคาเพียง 1,000 บาท! หลักสูตรภาษาอังกฤษ 2,500 บาท พร้อมรับใบประกาศนียบัตรทันที!',
                'AML/CTPF: Anti-Money Laundering and Counter Terrorism and Proliferation of Weapon of Mass Destruction Financing course certified by the Anti-Money Laundering Office (Thailand). Learn with ProbPlus today only for 2,500 Baht and receive intermediate certificate!')" />
                
        <ContentLoader :isDisplay="!contentReady" />

        <template v-if="contentReady">
            <ModalHomePopup :fields="fields" />

            <section class="testimonial-banner">
                <div class="container">
                    <div class="text">
                        <h1>{{ $PPlusEngine.getDictionary($route.params.lang,
                                'Get Your AML Skills Certified', 
                                'Get Your AML Skills Certified') }}</h1>
                        <p>
                            {{ $PPlusEngine.getDictionary($route.params.lang, 
                            'เปิดโลกรู้เท่าทันการฟอกเงินด้วยหลักสูตรที่ได้รับการรับรองโดยสำนักงานปปง.กับ ProbPlus ได้แล้ววันนี้ หลักสูตรภาษาไทยราคาเพียง 1,000 บาท! หลักสูตรภาษาอังกฤษ 2,500 บาท พร้อมรับใบประกาศนียบัตรทันที!',
                            'AML/CTPF: Anti-Money Laundering and Counter Terrorism and Proliferation of Weapon of Mass Destruction Financing course certified by the Anti-Money Laundering Office (Thailand). Learn with ProbPlus today only for 2,500 Baht and receive intermediate certificate!') }}
                        </p>
                        <router-link :to="'/' + $route.params.lang + '/course'" class="btn btn-main">{{ $PPlusEngine.getDictionary($route.params.lang, 
                        'เริ่มกันเลย', 
                        'Get Started') }}</router-link>
                    </div>
                </div>
            </section>
            <section class="why">
                <div class="container">
                    <div class="box">
                        <div class="picture">
                            <img src="@/assets/home-why.jpg" alt="Why" title="Why" />
                        </div>
                        <div class="desc" v-if="$route.params.lang == 'th'">
                            <h2>ทำไมถึงต้องอบรมและสอบวัดผล</h2>
                            <p>
                                เนื่องด้วยระเบียบคณะกรรมการป้องกันและปราบปรามการฟอกเงินว่าด้วยการจัดให้มีการฝึกอบรมให้แก่ผู้มีหน้าที่รายงานตามมาตรา 13 และมาตรา 16 พ.ศ. 2563 โดยต้องจัดให้เจ้าหน้าที่ที่เกี่ยวข้องกับการปฏิบัติงานด้านการจัดทำ หรือควบคุมการจัดทำรายงานการทำธุรกรรม การจัดให้ลูกค้าแสดงตน และ การตรวจสอบเพื่อทราบข้อเท็จจริงเกี่ยวกับลูกค้า เข้ารับการฝึกอบรมตามระเบียบนี้ ภายใน 30 วัน นับแต่วันเริ่มปฏิบัติงาน
                            </p>
                            <router-link :to="'/' + $route.params.lang + '/why'" class="btn btn-main-o">อ่านต่อ</router-link>
                        </div>
                        <div class="desc" v-if="$route.params.lang == 'en'">
                            <h2>Why Need to Learn</h2>
                            <p>
                                Due to the regulations of the Anti-Money Laundering Office (Thailand) on the provision of training for all persons who involved in the management or working in any related financing fields, the regulations require all these staffs must get AML course certified within 30 days from the starting of the operation
                            </p>
                            <router-link :to="'/' + $route.params.lang + '/why'" class="btn btn-main-o">Read More</router-link>
                        </div>
                    </div>
                </div>
            </section>
            <section class="step">
                <div class="container">
                    <h3>{{ $PPlusEngine.getDictionary($route.params.lang, 
                        'ต้องทำอะไรบ้าง?', 
                        'What to do?') }}</h3>
                    <div class="list">
                        <div class="item">
                            <i class="pe-7s-id"></i>
                            <h4>{{ $PPlusEngine.getDictionary($route.params.lang, 
                                '1. เข้าสู่ระบบ', 
                                '1. Sign In') }}</h4>
                            <span>{{ $PPlusEngine.getDictionary($route.params.lang, 
                                'กดเข้าสู่ระบบที่ ', 
                                'Click sign-in via the ') }}
                                <u class="link" @click="showRegisterModal()">
                                    {{ $PPlusEngine.getDictionary($route.params.lang, 
                                    'แบบฟอร์มเข้าสู่ระบบ', 
                                    'Sign In Form') }}
                                </u>
                            </span>
                        </div>
                        <div class="item">
                            <i class="pe-7s-credit"></i>
                            <h4>{{ $PPlusEngine.getDictionary($route.params.lang, 
                                '2. ชำระเงิน', 
                                '2. Pay') }}</h4>
                            <span>
                                {{ $PPlusEngine.getDictionary($route.params.lang, 
                                'ทำการโอนเงินและแจ้งหลักฐานการโอนเงินโดยท่านดูรายเอียดได้ที่', 
                                'Making payment and submit the transfer slip at ') }} <router-link :to="'/' + $route.params.lang + '/payment'">Link</router-link>
                            </span>
                        </div>
                        <div class="item">
                            <i class="pe-7s-display2"></i>
                            <h4>{{ $PPlusEngine.getDictionary($route.params.lang, 
                                '3. เข้าเรียน', 
                                '3. Learn') }}</h4>
                            <span>{{ $PPlusEngine.getDictionary($route.params.lang, 
                                'ภายใน 24 ช.ม. ระบบจะยืนยันสิทธิ์การเข้าเรียน ท่านสามารถเลือกบทเรียนได้เลยทันที', 
                                'Within 24 hours, the system will grant you the access to start learning our course') }}</span>
                        </div>
                        <div class="item">
                            <i class="pe-7s-note"></i>
                            <h4>{{ $PPlusEngine.getDictionary($route.params.lang, 
                                '4. สอบวัดผล', 
                                '4. Exam') }}</h4>
                            <span>
                                {{ $PPlusEngine.getDictionary($route.params.lang, 
                                'เมื่อท่านได้เรียนบทเรียนทั้งหมดแล้ว โปรดเข้าสู่การ', 
                                'Once, you have done all modules, please start taking ') }} <router-link :to="'/' + $route.params.lang + '/exam'">{{ $PPlusEngine.getDictionary($route.params.lang, 
                                'สอบวัดผล', 
                                'exam') }}</router-link> {{ $PPlusEngine.getDictionary($route.params.lang, 
                                'เพื่อขอรับใบรับรอง', 
                                ' for getting certification') }}
                            </span>
                        </div>
                        <div class="item">
                            <i class="pe-7s-medal"></i>
                            <h4>{{ $PPlusEngine.getDictionary($route.params.lang, 
                                '5. รับ Certificate', 
                                '5. Get Certificate') }}</h4>
                            <span>{{ $PPlusEngine.getDictionary($route.params.lang, 
                                'ถ้าผลคะแนนของท่านผ่านเกณฑ์ที่กำหนด ท่านสามารถดาวน์โหลดใบรับรองได้ทันที', 
                                'Once you already passed the exam, you can download or request your certification') }}</span>
                        </div>
                    </div>
                </div>
            </section>
            <section class="course">
                <div class="container">
                    <h3>{{ $PPlusEngine.getDictionary($route.params.lang, 
                        'บทเรียนของเรา', 
                        'Our Course') }}</h3>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-4" v-for="(item, index) in fields.coureList" :key="index">
                            <CourseBox :fields="item" />
                        </div>
                    </div>
                </div>
            </section>
            <ExamLink />
            <section class="about">
                <div class="container">
                    <div class="box">
                        <div class="desc" v-if="$route.params.lang == 'th'">
                            <h2>เรียนกับเรา ProbPlus</h2>
                            <p>
                                ถ้าหากว่าคุณก็ต้องการได้คำรับรองว่าเป็นผู้เชี่ยวชาญด้านการฟอกเงิน โดยไม่อยากเสียเวลาทั้งวันในห้องเรียน เบื่อความซ้ำซากจำเจในบทเรียนกฏหมายที่น่าเบื่อ และพร้อมที่จะเป็นผู้นำคนรุ่นใหม่ พวกเราเป็นกลุ่มคนรุ่นใหม่ที่ได้รับการยอมรับว่าเป็นผู้เชี่ยวชาญทางด้านกฏหมายฟอกเงินและได้รับการรับรองจากสำนักงานปปง. พวกเรามีระบบ e-Learning ที่คุณจะเรียนจากที่ไหนก็ได้ทุกเวลา และสามารถทำการสอบวัดผลเพื่อรับใบรับรองว่าจบหลักสูตรอย่างถูกต้องตามกฎหมาย
                            </p>
                        </div>
                        <div class="desc" v-if="$route.params.lang == 'en'">
                            <h2>Learn with ProbPlus</h2>
                            <p>
                                If you would like to get AML skill certified without attending within the classroom and ready to be a new leader, we are a new teenage company that provide the course which is already certified by the Anti-Money Laundering Office (Thailand). We have e-learning course which allow you to learn from anywhere at anytime. Moreover, we have provided the exam to test your knowledge and give you the certification for the course of "AML/CTPF : Anti-Money Laundering and Counter Terrorism and Proliferation of Weapon of Mass Destruction Financing" which is already approved by AMLO Thailand
                            </p>
                        </div>
                        <div class="picture"></div>
                    </div>
                </div>
            </section>
            <section class="customer">
                <div class="container">
                    <h3>{{ $PPlusEngine.getDictionary($route.params.lang, 
                        'องค์กรที่มาเรียนกับเรา', 
                        'Our Customers') }}</h3>
                    <div class="logo">
                        <img src="@/assets/customers/amex.jpg" alt="AMEX" title="AMEX" />
                        <img src="@/assets/customers/bitkub.jpg" alt="Bitkub" title="Bitkub" />
                        <img src="@/assets/customers/boa.jpg" alt="Bank of America" title="Bank of America" />
                        <img src="@/assets/customers/grab.jpg" alt="Grab" title="Grab" />
                        <br />
                        <img src="@/assets/customers/maybank.jpg" alt="Maybank" title="Maybank" />
                        <img src="@/assets/customers/mitsumetro.jpg" alt="Mitsu Metro" title="Mitsu Metro" />
                        <img src="@/assets/customers/msig.jpg" alt="MSIG" title="MSIG" />
                        <img src="@/assets/customers/nomura.jpg" alt="Nomura" title="Nomura" />
                        <img src="@/assets/customers/principal.jpg" alt="Principal" title="Principal" />
                    </div>
                </div>
            </section>
        </template>
    </div>
</template>

<script>
import ContentLoader from '@/weact/components/ContentLoader';
import CourseBox from '@/components/CourseBox';
import ModalHomePopup from '@/components/Modal/HomePopup';
import ExamLink from '@/components/ExamLink';

export default {
    components: { 
        ContentLoader,
        CourseBox,
        ModalHomePopup,
        ExamLink
    },
    data() {
        return {
            contentReady: false,
            fields: {}
        }
    },
    created() {
        let page = this;
        
        setTimeout(function(){
            page.getContent();
        }, this.$WeConfig.TimeLoader);
    },
    methods: {
        getContent() {
            let apiURL = this.$PPlusConfig.ApiURL;
            let postData = {
                langCode: this.$route.params.lang
            };

            this.$WeHelper.postAPI(apiURL, '/api/home/get-content', postData).then((response) => {
                this.fields = response.data;
                this.contentReady = true;
            });
        },
        showRegisterModal() {
            this.$PPlusModal.register();
        }
    }
}
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.page-home {
    .testimonial-banner {
        background-image: url(../assets/home-banner.jpg);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        height: 500px;
        display: flex;
        align-items: center;

        @media only screen and (max-width: $screenLarge) {
            height: 400px;
        }

        @media only screen and (max-width: $screenMedium) {
            height: 300px;
        }

        .text {
            width: 50%;

            @media only screen and (max-width: $screenMedium) {
                width: 100%;
            }

            h1 {
                font-size: 54px;
                font-weight: 200;
                color: #fff;
                margin: 0;
                text-shadow: 0 0 5px rgba(0, 0, 0, 0.2);

                @media only screen and (max-width: $screenSmall) {
                    font-size: 34px;
                }

                @media only screen and (max-width: $screenExtraSmall) {
                    font-size: 24px;
                }
            }

            p {
                font-size: 16px;
                line-height: 28px;
                color: rgba(255, 255, 255, 0.9);
                margin: 10px 0 30px;
                text-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
                
                @media only screen and (max-width: $screenExtraSmall) {
                    margin: 10px 0 20px;
                    font-size: 13px;
                    line-height: 20px;
                }

                strong {
                    font-size: 22px;
                    vertical-align: baseline;
                    color: #fff;

                    @media only screen and (max-width: $screenExtraSmall) {
                        font-size: 16px;
                    }
                }
            }
        }
    }

    h3 {
        font-size: 32px;
        font-weight: 200;
        margin: 0;
        color: #666;
        text-align: center;

        @media only screen and (max-width: $screenExtraSmall) {
            font-size: 26px;
        }
    }

    .why {
        padding: 50px 0;

        .box {
            background: #fff;
            overflow: hidden;

            .picture {
                width: 50%;
                float: left;

                @media only screen and (max-width: $screenMedium) {
                    width: 100%;
                    float: none;
                }

                img {
                    display: block;
                    width: 100%;
                }
            }

            .desc {
                width: 50%;
                padding: 30px;
                float: left;

                @media only screen and (max-width: $screenLarge) {
                    padding: 20px 30px;
                }

                @media only screen and (max-width: $screenMedium) {
                    width: 100%;
                    float: none;
                }

                @media only screen and (max-width: $screenSmall) {
                    padding: 20px;
                }
                
                h2 {
                    font-size: 32px;
                    font-weight: 200;
                    color: #333;
                    margin: 0;

                    @media only screen and (max-width: $screenLarge) {
                        font-size: 24px;
                    }

                    &:after {
                        content: " ";
                        display: block;
                        width: 100px;
                        height: 1px;
                        background: $mainColor;
                        margin-top: 12px;
                    }
                }

                p {
                    font-size: 14px;
                    color: #999;
                    margin: 0;
                    padding: 20px 0 30px;

                    @media only screen and (max-width: $screenLarge) {
                        padding: 20px 0;
                    }
                }
            }
        }
    }

    .step {
        background: #fff;
        padding: 40px 0 50px;

        .list {
            text-align: center;
            margin-top: 20px;

            .item {
                @include verticalAlign(top);
                width: 200px;
                margin: 10px 10px 0;

                i {
                    display: block;
                    font-size: 70px;
                    color: #bbb;
                    width: 120px;
                    height: 120px;
                    margin: auto;
                    padding-top: 23px;
                    border: 1px solid #aaa;
                    @include borderRadius(1000px);
                }

                h4 {
                    font-size: 22px;
                    color: #666;
                    margin: 10px 0;
                }

                span {
                    display: block;
                    font-size: 15px;
                    color: #777;

                    u {
                        cursor: pointer;
                    }
                    
                    a {
                        text-decoration: underline;
                    }
                }

                u.link {
                    color: #17a2b8;
                }
            }
        }
    }

    .course {
        padding: 40px 0 50px;
    }

    .about {
        padding: 50px 0;

        .box {
            position: relative;
            background: url(../assets/home-about-bg.png) #508683;
            overflow: hidden;

            .desc {
                width: 50%;
                padding: 30px;

                @media only screen and (max-width: $screenMedium) {
                    width: 100%;
                    float: none;
                }
                
                h2 {
                    font-size: 36px;
                    font-weight: 200;
                    color: #fff;
                    margin: 0;

                    @media only screen and (max-width: $screenLarge) {
                        font-size: 28px;
                    }

                    &:after {
                        content: " ";
                        display: block;
                        width: 100px;
                        height: 1px;
                        background: rgba(255, 255, 255, 0.5);
                        margin-top: 20px;
                    }
                }

                p {
                    font-size: 16px;
                    line-height: 28px;
                    color: rgba(255, 255, 255, 0.8);
                    margin: 0;
                    padding: 25px 0 0;
                    
                    @media only screen and (max-width: $screenLarge) {
                        font-size: 14px;
                        line-height: 24px;
                        padding: 20px 0 0;
                    }
                }
            }

            .picture {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                width: 50%;
                background: url(../assets/about-decoration-2.jpg) center center;
                background-size: cover;

                @media only screen and (max-width: $screenMedium) {
                    display: none;
                }
            }
        }
    }

    .customer {
        background: #fff;
        padding: 50px 0;

        .logo {
            text-align: center;
            margin-top: 40px;

            img {
                display: inline-block;
                margin: 10px 20px;
                height: 100px;

                @media only screen and (max-width: $screenExtraSmall) {
                    margin: 10px;
                }
            }
        }
    }
}
</style>